module.exports = __webpack_public_path__ + "img/invite_ios.ff068476.png";